export default __webpack_public_path__ + "static/media/objectives_icon_2.4f4c0555.png";